import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { css } from '@emotion/react';
import { CompanyListContainerBreakpoints, ContainerName } from '../../../../constants/styles';
import { SearchInput } from '../../../../CoreComponents/base/SearchInput';
import {
  activeCompanyListIdStateJ,
  activeListStateJ,
  companyListStateJ,
} from '../../../../services/state/ListsStateJ';
import { listSearchQueryStateJ } from '../state/FiltersStateJ';
import { OwnerFilter } from './OwnerFilter';
import { SectorFilter } from './SectorFilter';
import { TogglePreviousDealsSelector } from './TogglePreviousDealsSelector';

const filterSize = '16rem';

const FilterContainer = css`
  margin: 1rem 0 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(${filterSize}, 1fr));
  gap: 1rem;
  justify-content: start;

  @container ${ContainerName.companyLists} (max-width: ${CompanyListContainerBreakpoints.medium}px) {
    grid-template-columns: repeat(2, minmax(${filterSize}, 1fr));
    & [data-id='list-owner-filter'] {
      display: none;
    }
  }
  @container ${ContainerName.companyLists} (max-width: ${CompanyListContainerBreakpoints.small}px) {
    grid-template-columns: ${filterSize};
    & [data-id='list-sector-filter'] {
      display: none;
    }
    & [data-id='list-owner-filter'] {
      display: none;
    }
  }
`;

const FilterSelectorWrapper = css`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const MainContainer = css`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  column-gap: 1rem;
`;

export function FiltersAndViewSettings() {
  const activeListId = useAtomValue(activeCompanyListIdStateJ);
  const activeList = useAtomValue(activeListStateJ);

  const companyList = useAtomValue(companyListStateJ(activeListId));
  const setListSearchQuery = useSetAtom(listSearchQueryStateJ);

  useEffect(() => {
    setListSearchQuery('');
    return () => {
      setListSearchQuery('');
    };
  }, [activeListId, setListSearchQuery]);

  if (!companyList?.items?.length) {
    return null;
  }

  return (
    <div css={MainContainer} key={activeListId}>
      <div css={FilterContainer}>
        {/* marginTop for alignment with the dropdown */}
        <SearchInput onChange={setListSearchQuery} style={{ marginTop: '0.5rem' }} />
        <div data-id={'list-sector-filter'}>
          <SectorFilter />
        </div>
        {activeList?.type === 'discovery' && (
          <div data-id={'list-owner-filter'}>
            <OwnerFilter />
          </div>
        )}
      </div>
      {
        <div css={FilterSelectorWrapper}>
          {activeList?.type === 'discovery' && <TogglePreviousDealsSelector />}
        </div>
      }
    </div>
  );
}
